import { graphql } from "react-relay";

export const QUERY = graphql`
	query discountCodeScreen_Query(
		$id: ID!
		$filterByUsedAtFrom: ZonedDateTIme
		$filterByUsedToFrom: ZonedDateTIme
	) {
		node(id: $id) {
			... on DiscountCode {
				code
				...DiscountCodeForm_DiscountCodeFragment
			}
		}
		...DiscountCodeUsageTable_DiscountCodeFragment
			@arguments(
				first: 10
				after: null
				id: $id
				filterByUsedAtFrom: $filterByUsedAtFrom
				filterByUsedToFrom: $filterByUsedToFrom
			)
	}
`;
